import { render, staticRenderFns } from "./index2023-10-18.vue?vue&type=template&id=b4feeed4&scoped=true&"
import script from "./index2023-10-18.vue?vue&type=script&lang=js&"
export * from "./index2023-10-18.vue?vue&type=script&lang=js&"
import style0 from "./index2023-10-18.vue?vue&type=style&index=0&id=b4feeed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4feeed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4feeed4')) {
      api.createRecord('b4feeed4', component.options)
    } else {
      api.reload('b4feeed4', component.options)
    }
    module.hot.accept("./index2023-10-18.vue?vue&type=template&id=b4feeed4&scoped=true&", function () {
      api.rerender('b4feeed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/draftCopy/index2023-10-18.vue"
export default component.exports